

















	import { MyActions } from '@/models/Store/State';
	import { userRaid } from 'models/Types';
	import Vue, { PropType } from 'vue';

    export default Vue.extend({
        name: "ListRaidComp",
		props: {
			raid: Object as PropType<userRaid>,
			anmeldung: Object
		},
        computed: {
            role: function(): string {
                switch(this.raid.role) {
                    case 0: return "Spieler";
                    case 1: return "Lieutenant";
                    case 2: return "Raidleiter";
                    default: return "";
                }
            },
            icon: function(): string {
                if (this.anmeldung) {
                    const icons = ['check_circle', 'check_circle_outline', 'cancel', 'warning'];
                    return icons.slice(this.anmeldung.type)[0];
                } else {
                    return '';
                }
            }
        },
        methods: {
            saveRaid: function() {
                this.$vStore.dispatch(MyActions.OpenRaid, this.raid);
            }
        }
    })
